<template>
  <div class="demo-tabs-style2">
    <Tabs
      type="card"
      :animated="false"
      name="tab1"
      :value="tabValue"
      @on-click="clickTab"
    >
      <TabPane
        :label="$t('Performance_Appraisal')"
        v-if="this.$route.query.plan == '1' || tabValue"
        tab="tab1"
        name="1"
        ><PerformanceEvaluation
          ref="PerformanceEvaluation"
        ></PerformanceEvaluation
      ></TabPane>
      <TabPane
        :label="$t('RepeatPersonnel')"
        v-if="this.$route.query.plan == '1' || tabValue"
        tab="tab1"
        name="4"
        ><PerformanceEvaluationCopy
          ref="PerformanceEvaluationCopy"
        ></PerformanceEvaluationCopy
      ></TabPane>
      <!-- <TabPane label="人才标签" v-if="this.$route.query.plan=='1'" tab="tab1" name="3"><CapabilityAssessment ref="CapabilityAssessment"></CapabilityAssessment></TabPane> -->
      <!-- <TabPane label="继任者盘点" v-if="this.$route.query.plan=='1'|| this.$route.query.plan=='2'" tab="tab1" name="2"><SuccessionInventory ref="SuccessionInventory"></SuccessionInventory></TabPane> -->
    </Tabs>

    <!-- <div style="margin:20px 0;display:flex;justify-content: center;">
            <Button type="primary" @click="returnPage">返回</Button>
        </div> -->
  </div>
</template>

<script>
import PerformanceEvaluation from "./components/PerformanceEvaluation.vue";
import PerformanceEvaluationCopy from "./components/PerformanceEvaluationCopy.vue";
import SuccessionInventory from "./components/SuccessionInventory.vue";
import CapabilityAssessment from "./components/CapabilityAssessment.vue";
export default {
  components: {
    PerformanceEvaluation,
    SuccessionInventory,
    CapabilityAssessment,
    PerformanceEvaluationCopy
  },
  data() {
    return {
      tabValue: "1"
    };
  },
  mounted() {
    this.$route.query.plan ? (this.tabValue = this.$route.query.plan) : "4";
    if (this.$route.query.plan) {
      if (this.tabValue == "1") {
        this.$nextTick(() => {
          this.$refs.PerformanceEvaluation.showreturnbtn = true;
          this.$refs.PerformanceEvaluation.id = this.$route.query.id;
          this.$refs.PerformanceEvaluation.beEnd = this.$route.query.beEnd;
          this.$refs.PerformanceEvaluation.getData();
          this.$refs.PerformanceEvaluation.getListData();
        });
      }
      if (this.$route.query.plan == "2") {
        this.$nextTick(() => {
          this.$refs.SuccessionInventory.showreturnbtn = true;
        });
      }
      // this.$refs.SuccessionInventory.id=this.$route.query.id
      // this.$refs.SuccessionInventory.getData()
    } else {
      this.$nextTick(() => {
        if (this.tabValue == "1") {
          this.$refs.PerformanceEvaluation.$refs.FormComponent.levelDisabledState = true;
          this.$refs.PerformanceEvaluation.$refs.FormComponent.levelDisabled = true;
          this.$refs.PerformanceEvaluation.$refs.FormComponent.pShow = true;
          this.$refs.PerformanceEvaluation.getData();
          this.$refs.PerformanceEvaluation.getListData();
        } else if (this.tabValue == "4") {
          this.$refs.PerformanceEvaluationCopy.$refs.FormComponent.levelDisabledState = true;
          this.$refs.PerformanceEvaluationCopy.$refs.FormComponent.levelDisabled = true;
          this.$refs.PerformanceEvaluationCopy.$refs.FormComponent.pShow = true;
          this.$refs.PerformanceEvaluationCopy.getData();
          this.$refs.PerformanceEvaluationCopy.getListData();
        }
      });

      // this.$refs.PerformanceEvaluation.showreturnbtn=false
      // this.$refs.SuccessionInventory.showreturnbtn=false
    }
    // if(this.$route.query.plan=='1'){
    //     this.$nextTick(() => {
    //         this.$refs.CapabilityAssessment.id=this.$route.query.id
    //         this.$refs.CapabilityAssessment.getData()
    //         this.$refs.CapabilityAssessment.getListData()
    //     })
    // }
    //  if(this.$route.query.id ){
    //     this.$nextTick(() => {
    //         this.$refs.SuccessionInventory.id=this.$route.query.id
    //         this.$refs.SuccessionInventory.getData()
    //     })
    // }
  },
  methods: {
    returnPage() {
      this.$router.back();
    },
    clickTab(name) {
      if (name == "1") {
        this.$refs.PerformanceEvaluation.$refs.FormComponent.levelDisabledState = true;
        this.$refs.PerformanceEvaluation.$refs.FormComponent.levelDisabled = true;
        this.$refs.PerformanceEvaluation.$refs.FormComponent.pShow = true;
        this.$refs.PerformanceEvaluation.getData();
        this.$refs.PerformanceEvaluation.getListData();
      } else if (name == "4") {
        this.$refs.PerformanceEvaluationCopy.$refs.FormComponent.levelDisabledState = true;
        this.$refs.PerformanceEvaluationCopy.$refs.FormComponent.levelDisabled = true;
        this.$refs.PerformanceEvaluationCopy.$refs.FormComponent.pShow = true;
        this.$refs.PerformanceEvaluationCopy.getData();
        this.$refs.PerformanceEvaluationCopy.getListData();
      }
    }
  }
};
</script>

<style>
.demo-tabs-style2 > .ivu-tabs.ivu-tabs-card > .ivu-tabs-bar .ivu-tabs-tab {
  border-radius: 0;
  background: #459846;
  color: #ffffff;
}
.demo-tabs-style2
  > .ivu-tabs.ivu-tabs-card
  > .ivu-tabs-bar
  .ivu-tabs-tab-active {
  /* border-top: 1px solid #ffffff; */
  background: #ffffff;
  border-top: 1px solid #459846 !important;
  border-left: 1px solid #459846 !important;
  border-right: 1px solid #459846 !important;
  color: #333333;
}
.demo-tabs-style2
  > .ivu-tabs.ivu-tabs-card
  > .ivu-tabs-bar
  .ivu-tabs-tab-active:before {
  /* content: '';
        display: block;
        width: 100%;
        height: 1px;
        background: #ffffff;
        position: absolute;
        top: 0;
        left: 0;
        color: #459846; */
}
/* .card-tabs-search >>>.ivu-tabs.ivu-tabs-card {
    border-color:#8CD29B;
  }
 
  .card-tabs-search >>>.ivu-tabs.ivu-tabs-card >.ivu-tabs-bar .ivu-tabs-tab-active{
    background:#8CD29B;
    color: #f5f7f9;
    height:52px;
    border-color:#8CD29B;
  }
  .card-tabs-search >>>.ivu-tabs.ivu-tabs-card >.ivu-tabs-bar .ivu-tabs-tab-focused{
      border-color:#8CD29B;
  }
  .ivu-tabs-nav-container:focus .ivu-tabs-tab-focused {
      border-color:#8CD29B;
  } */
</style>



// WEBPACK FOOTER //
// src/components/process/performanceManagement/AchCorrectApproval.vue